import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import localforage from "localforage";
import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CustomTable from "../../../components/CustomTable";
import { filterList } from "../../../libs/utils";
import { getFAQList, deleteFaq } from "../../../services/faq";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";

function ListFaq() {
  const [rows, setRows] = useState();
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [faqToDelete, setFaqToDelete] = useState(null);

  const columns = [
    { id: "Question", label: "Question", minWidth: 300 },
    {
      id: "Answers",
      label: "Answers",
      minWidth: 300,
      align: "left",
    },
    {
      id: "Offers",
      label: "Offers",
      minWidth: 100,
      align: "left",
    },
    {
      id: "Popularity",
      label: "Popularity",
      minWidth: 100,
      align: "center",
      enableSort: true,
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 100,
      align: "right",
    },
  ];

  const searchData = (e) => {
    setSearchKey(e.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = (faq) => {
    setFaqToDelete(faq);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!faqToDelete) return;
    const id = faqToDelete.id;
    try {
      setLoading(true);
      await deleteFaq(id);
      // Update local state
      setRows(rows.filter(row => row.id !== id));
      // Update cache
      localforage.getItem("@faqlists", (error, data) => {
        if (data) {
          const updatedData = data.filter(item => item.id !== id);
          localforage.setItem("@faqlists", updatedData);
        }
      });
    } catch (error) {
      Swal.fire({
        title: "Oops",
        text: error?.data?.error,
        icon: "warning",
        confirmButtonText: "Ok",
      })
    } finally {
      setLoading(false);
      setDeleteDialogOpen(false);
      setFaqToDelete(null);
    }
  };

  const dataGenerator = (d) => {
    return {
      Question: d.question,
      Answers: d.answer,
      Offers: String(
        d.offerList.map((v, index) => {
          return `${v.advertiserName} (${v.affiliatePartner})`;
        })
      ),
      Popularity: d.popularity,
      id: d.id,
      Action: (
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Link to={`/app/faq/${d.objectId}`} style={{ textDecoration: "none" }}>
            <Button variant="contained" size="small" color="warning">
              Edit
            </Button>
          </Link>
          <Button 
            variant="contained" 
            size="small" 
            color="error"
            onClick={() => handleDeleteClick(d)}
          >
            Delete
          </Button>
        </Box>
      ),
    };
  };
console.log(rows);
  useEffect(() => {
    setLoading(true);
    localforage.getItem("@faqlists", (error, data) => {
      if (data) {
        if (data?.length > 0 && typeof data === "object") {
          setRows(data.map((d) => dataGenerator(d)));
        } else {
          setRows([]);
        }
      }
    });
    getFAQList()
      .then((response) => {
        setLoading(false);
        if (response?.length > 0 && typeof response === "object") {
          setRows(response.map((d) => dataGenerator(d)));
        } else {
          setRows([]);
        }
        localforage.setItem("@faqlists", response, (error, data) => {
          if (error) {
            throw error;
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        throw error;
      });
  }, []);

  return (
    <>
      <Box sx={{ px: 6 }}>
        <div className="bankAddRuleHeader mb-3">
          <div
            style={{
              display: "flex",
              padding: "1.5rem 0",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "#33343a" }} variant="h4" component="h4">
              FAQ List
            </Typography>
            {loading && (
              <div
                style={{
                  marginLeft: "12px",
                  color: "#a0a0a0",
                  fontSize: "24px",
                }}
              >
                <i
                  className={`fa fa-refresh ${
                    loading === true ? "fa-spin" : ""
                  }`}
                  aria-hidden="true"
                ></i>
              </div>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "end" }}>
            <TextField
              id="standard-basic"
              label="Search"
              variant="standard"
              sx={{ mr: 1 }}
              onKeyUp={(e) => searchData(e)}
              InputProps={{
                endAdornment: <SearchIcon sx={{ color: "#8a8a8a" }} />,
              }}
            />

            <Tooltip title="Choose Option">
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MoreVertIcon sx={{ width: 32, height: 32 }} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem
                sx={{
                  "&:hover": {
                    background: "#f9da8792",
                    color: "#000",
                  },
                }}
              >
                <Link to="/app/faq/0" style={{ color: "#040721" }}>
                  Add FAQ
                </Link>
              </MenuItem>
            </Menu>
          </div>
        </div>

        <CustomTable
          data={filterList(rows, searchKey) || []}
          columns={columns}
        />
      </Box>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Delete FAQ</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this FAQ? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button 
            onClick={handleDeleteConfirm} 
            color="error" 
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ListFaq;
